import { ReactNode } from 'react';
import clsx from 'clsx';
import { useSortable } from '@dnd-kit/react/sortable';

type Props = {
    id: string;
    index: number;
    children: ReactNode;
};

/**
 * Wraps a selection row as a dnd-kit sortable. The whole row is the drag source
 * (dnd-kit ignores presses that start on interactive controls), and the library
 * animates the live reordering while dragging. Touch dragging is enabled via the
 * pointer-sensor config and `touch-action: none` on the row (see ProjectPage).
 */
export const SortableSelectionRow = ({ id, index, children }: Props) => {
    const { ref, isDragging } = useSortable({ id, index });

    return (
        <div
            ref={ref}
            className={clsx('vss-project-page__row', {
                'vss-project-page__row--dragging': isDragging,
            })}
        >
            {children}
        </div>
    );
};
